<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <!-- Nevigater -->
        <v-layout mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.push('/post-approve')"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="viewData"
          >
            <span>ดูข้อมูล</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3E7662;font-weight: bold;font-size: 24px;"
          >
            <span>รายงานการเบี่ยงเบนโครงร่างวิจัย</span>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex>
            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: left;font-size: 28px;color: white"
                @click="setData"
              >
                <div style="font-weight: bold">
                  แบบรายงานการไม่ปฏิบัติตามข้อกำหนด
                </div>
                <div style="font-size: 18px;">
                  Non-compliance / Protocol Deviation / Prootocol Violation
                  Report
                </div>
              </v-flex>
              <v-flex
                ml-8
                pt-8
                pr-8
                style="text-align: right;font-weight: bold;font-size: 13px;color: white"
              >
                <span>RF 05_2563</span>
              </v-flex>
            </v-layout>
            <!-- blog 1 -->
            <v-card class="mb-12 px-12">
              <v-layout py-12 pr-8 mr-12 style="font-size: 16px;">
                <v-flex>
                  <!-- row 1 -->
                  <v-layout pt-8>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>รหัสโครงร่างการวิจัย</span>
                    </v-flex>
                    <v-flex xs4>
                      <textfield-form
                        :model="form.researchCode"
                        @update-data="updateData('researchCode', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ชื่อผู้วิจัยหลัก</span>
                    </v-flex>
                    <v-flex xs4>
                      <textfield-form
                        :model="form.firstName"
                        @update-data="updateData('firstName', $event)"
                      ></textfield-form>
                    </v-flex>
                    <v-flex
                      xs2
                      pr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>นามสกุล</span>
                    </v-flex>
                    <v-flex xs4>
                      <textfield-form
                        :model="form.lastName"
                        @update-data="updateData('lastName', $event)"
                      ></textfield-form>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout pb-6>
                    <v-flex
                      xs2
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <span>ชื่อโครงการวิจัย (ไทย)</span>
                    </v-flex>
                    <v-flex xs10>
                      <textarea-form
                        :model="form.researchName"
                        @update-data="updateData('researchName', $event)"
                      ></textarea-form>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!--blog 2-->
            <v-card class="mb-12">
              <v-layout py-12 px-8>
                <v-flex>
                  <!-- row 1 -->
                  <v-layout pt-8>
                    <v-flex xs4>
                      <v-layout>
                        <v-flex
                          xs4
                          mr-2
                          pt-2
                          style="text-align: right;font-weight: bold;"
                        >
                          <span>จำนวนรายงาน</span>
                        </v-flex>
                        <v-flex xs8>
                          <textfield-form
                            :model="form.amountOfReport"
                            @update-data="updateData('amountOfReport', $event)"
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs8>
                      <v-layout>
                        <v-flex
                          xs6
                          mr-2
                          pt-2
                          style="text-align: right;font-weight: bold;"
                        >
                          <span
                            >จำนวนอาสาสมัครที่มีการไม่ปฏิบัติตามข้อกำหนด</span
                          >
                        </v-flex>
                        <v-flex xs6>
                          <textfield-form
                            :model="form.amountOfNotFollow"
                            @update-data="
                              updateData('amountOfNotFollow', $event)
                            "
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!-- row 2 -->
                  <div v-for="(input, k) in subjectData" :key="k">
                    <v-layout>
                      <v-flex xs4>
                        <v-layout>
                          <v-flex
                            xs4
                            mr-2
                            pt-2
                            style="text-align: right;font-weight: bold;"
                          >
                            <span>Subject No.</span>
                          </v-flex>
                          <v-flex xs8>
                            <textfield-form
                              :model="input.subjectNumber"
                              @update-data="
                                updateDataMultiRow('subjectNumber', k, $event)
                              "
                            ></textfield-form>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs8>
                        <v-layout justify-space-around>
                          <v-flex
                            ml-6
                            mr-n3
                            shrink
                            pt-2
                            style="font-weight: bold;"
                          >
                            <span>Date of Events</span>
                          </v-flex>
                          <v-flex xs2>
                            <textfield-form
                              :model="input.dateOfEvents"
                              @update-data="
                                updateDataMultiRow('dateOfEvents', k, $event)
                              "
                            ></textfield-form>
                          </v-flex>
                          <v-flex
                            mr-n4
                            shrink
                            pt-2
                            style="text-align: right;font-weight: bold;"
                          >
                            <span>Date of Acknowledgement</span>
                          </v-flex>
                          <v-flex xs2>
                            <textfield-form
                              :model="input.dateOfAcknowledgement"
                              @update-data="
                                updateDataMultiRow(
                                  'dateOfAcknowledgement',
                                  k,
                                  $event
                                )
                              "
                            ></textfield-form>
                          </v-flex>
                          <v-flex shrink>
                            <v-btn
                              style="background-color: white; color: #3E7662; width: 80px"
                              @click="remove(k)"
                              v-if="k != subjectData.length - 1"
                            >
                              <v-icon>remove</v-icon>
                              <span>ลบ</span>
                            </v-btn>
                            <v-btn
                              dark
                              style="width: 80px;background-color: #3E7662"
                              @click="add(k)"
                              v-if="k == subjectData.length - 1"
                            >
                              <v-icon>add</v-icon>
                              <span>เพิ่ม</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>

            <!--blog 3-->

            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: center;font-size: 18px;color: white"
              >
                <div style="font-weight: bold">Type of Report</div>
              </v-flex>
            </v-layout>
            <v-card class="mb-12 px-12 py-12">
              <!--group 1-->
              <v-layout px-12>
                <v-flex
                  xs4
                  :class="!form.hasDeviation ? '' : 'color-label-checkbox'"
                  style="font-weight: bold;font-size: 18px"
                  d-flex
                  justify-start
                >
                  <v-checkbox
                    v-model="form.hasDeviation"
                    color="#3E7662"
                    label="Protocol Deviation"
                  ></v-checkbox>
                </v-flex>
                <!-- @change="clearCheckbox('hasDeviation')" -->
                <v-flex
                  xs4
                  :class="!form.hasDeviation ? '' : 'color-label-checkbox'"
                  style="font-weight: bold;font-size: 18px"
                  d-flex
                  justify-start
                >
                  <v-checkbox
                    v-model="form.hasViolation"
                    color="#3E7662"
                    label="Protocol Violation"
                  ></v-checkbox>
                  <!-- @change="clearCheckbox('hasViolation')" -->
                </v-flex>
              </v-layout>
              <v-layout mt-2 style="padding-left: 100px">
                <v-flex>
                  <!-- row 1 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      :class="!form.hasRandom ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        v-model="form.hasRandom"
                        hide-details
                        color="#3E7662"
                        label="สุ่มอาสาสมัครที่ไม่มีคุณสมบัติเหมาะสม (Randomization of ineligible subjects)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      :class="!form.hasEnrollment ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        v-model="form.hasEnrollment"
                        hide-details
                        color="#3E7662"
                        label="รับอาสาสมัครที่เข้าข่ายคัดออกจากโครงการ (Enrollment of excluded subjects)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      :class="
                        !form.hasNotScreening ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        v-model="form.hasNotScreening"
                        hide-details
                        color="#3E7662"
                        label="ไม่ได้ทำตามขั้นตอนการคัดกรองที่ระบุ (Do not perform screening procedures required by protocol)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 4 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="!form.hasScreening ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        hide-details
                        color="#3E7662"
                        v-model="form.hasScreening"
                        label="ดำเนินการคัดกรองหรือขั้นตอนการวิจัยนอกระยะเวลาที่กำหนด (Perform screening or procedures outside the time required by protocal)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!--row 5-->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="
                        !form.hasFailureTherapy ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        hide-details
                        color="#3E7662"
                        v-model="form.hasFailureTherapy"
                        label="ให้การรักษา หรือให้ยาไม่ตรงตามที่ระบุ (Failure to provide therapy or mendication by protocal)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!--row6-->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="
                        !form.hasFailureAccomplish ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        hide-details
                        color="#3E7662"
                        v-model="form.hasFailureAccomplish"
                        label="ทำหัตถการวิจัยที่ระบุไว้ไม่ครบถ้วน (Failure to accomplish procedures required by protocal)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!--row7-->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="!form.hasFollowUp ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        hide-details
                        color="#3E7662"
                        v-model="form.hasFollowUp"
                        label="นัดหมายไม่ตรงตามระบุ (Follow-up visit outside the time schedule required by protocal"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!--row8-->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="!form.hasOther1 ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        :disabled="!form.hasDeviation"
                        hide-details
                        color="#3E7662"
                        v-model="form.hasOther1"
                        label="อื่นๆ (Others) ระบุ"
                        @change="clearCheckbox('hasOther1')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex ml-3 xs8>
                      <textfield-form-append
                        :disabled="!form.hasOther1"
                        :model="form.other1"
                        @update-data="updateData('other1', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <!--group2-->

              <v-layout px-12 pt-12>
                <v-flex
                  xs6
                  :class="!form.hasNonCompliance ? '' : 'color-label-checkbox'"
                  style="font-weight: bold;font-size: 18px"
                  d-flex
                  justify-start
                >
                  <v-checkbox
                    v-model="form.hasNonCompliance"
                    color="#3E7662"
                    label="Non-Compliance"
                    @change="clearCheckbox('hasNonCompliance')"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <v-layout mt-2 style="padding-left: 100px">
                <v-flex>
                  <!-- row 1 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      :class="
                        !form.hasDelaySAEReport ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        :disabled="!form.hasNonCompliance"
                        v-model="form.hasDelaySAEReport"
                        hide-details
                        color="#3E7662"
                        label="ส่งรายงานเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรงล่าช้า (Delay sending SAE report)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      :class="
                        !form.hasDelayContinuingReport
                          ? ''
                          : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        :disabled="!form.hasNonCompliance"
                        v-model="form.hasDelayContinuingReport"
                        hide-details
                        color="#3E7662"
                        label="รส่งรายงานความก้าวหน้าของการวิจัยล่าช้า (Delay sending continuing report)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      :class="
                        !form.hasUseUnstampedInformed
                          ? ''
                          : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        :disabled="!form.hasNonCompliance"
                        v-model="form.hasUseUnstampedInformed"
                        hide-details
                        color="#3E7662"
                        label="ใช้เอกสารชี้แจงข้อมูลแก่อาสาสมัครฉบับที่ไม่ประทับตรายางของคณะกรรมการกลางฯ (Use unstamped informed consent form)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="
                        !form.hasAccountabilityDrug
                          ? ''
                          : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        :disabled="!form.hasNonCompliance"
                        hide-details
                        color="#3E7662"
                        v-model="form.hasAccountabilityDrug"
                        label="การบริหารจัดการผลิตภัณฑ์ยาที่ใช้ในการวิจัยที่เหมาะสม (Impropor drug accountability)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="!form.hasOther2 ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        :disabled="!form.hasNonCompliance"
                        hide-details
                        color="#3E7662"
                        v-model="form.hasOther2"
                        label="อื่นๆ (Others) ระบุ"
                        @change="clearCheckbox('hasOther2')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex ml-3 xs8>
                      <textfield-form-append
                        :disabled="!form.hasOther2"
                        :model="form.other2"
                        @update-data="updateData('other2', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: center;font-size: 18px;color: white"
              >
                <div style="font-weight: bold">
                  รายละเอียดของการไม่ปฏิบัติตามระเบียบข้อกำหนด (Narrative
                  summary of the event
                </div>
              </v-flex>
            </v-layout>
            <!-- blog 4 -->
            <v-card class="mb-12 px-12">
              <v-layout py-12 style="font-size: 16px;">
                <v-flex>
                  <textarea-form
                    :model="form.summaryOfTheEvent"
                    :rows="10"
                    background-color="#FBF6F3"
                    @update-data="updateData('summaryOfTheEvent', $event)"
                  ></textarea-form>
                </v-flex>
              </v-layout>
            </v-card>

            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: center;font-size: 18px;color: white"
              >
                <div style="font-weight: bold">การตอบสนอง (Action Taken)</div>
              </v-flex>
            </v-layout>
            <!-- blog 5 -->
            <v-card class="mb-12 px-12">
              <v-layout py-12 mt-2 style="padding-left: 70px">
                <v-flex>
                  <!-- row 1 -->
                  <v-layout>
                    <v-flex
                      :class="
                        !form.hasSubjectWithdraw ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        v-model="form.hasSubjectWithdraw"
                        hide-details
                        color="#3E7662"
                        label="ถอนอาสาสมัครการวิจัย (Subject withdrawn)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout>
                    <v-flex
                      :class="
                        !form.hasSubjectWithdrawWithFollowUp
                          ? ''
                          : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        v-model="form.hasSubjectWithdrawWithFollowUp"
                        hide-details
                        color="#3E7662"
                        label="ถอนอาสาสมัครการวิจัย และติดตาม (Subject withdrawn with follow up visit required)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!--row 3-->
                  <v-layout>
                    <v-flex
                      :class="
                        !form.hasSubjectRemainButFollow
                          ? ''
                          : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        v-model="form.hasSubjectRemainButFollow"
                        hide-details
                        color="#3E7662"
                        label="อาสาสมัครยังคงอยู่ในการวิจัย แต่ติดตามสังเกตอาการอสสาสมัครอย่างใกล้ชิด (Subject remains on the but data analysis will be modified)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex
                      :class="
                        !form.hasSubjectRemainButStudy
                          ? ''
                          : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        v-model="form.hasSubjectRemainButStudy"
                        hide-details
                        color="#3E7662"
                        label="อาสาสมัครยังคงอยู่ในการวิจัย แต่ปรับแก้ไขการวิเคราะห์ข้อมูลทางสถิติ (Subject remains on the study but data analysis will be modified)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 4 -->
                  <v-layout>
                    <v-flex
                      shrink
                      :class="
                        !form.hasSponsorNotified ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        hide-details
                        color="#3E7662"
                        v-model="form.hasSponsorNotified"
                        label="แจ้งผู้สนับสนุนทุนวิจัยหรือผู้วิจัยหลัก Sponsor or Principle Investigator notified on date"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="!form.hasOther3 ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        hide-details
                        color="#3E7662"
                        v-model="form.hasOther3"
                        label="อื่นๆ (Others) ระบุ"
                        @change="clearCheckbox('hasOther3')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex ml-3 xs8>
                      <textfield-form-append
                        :disabled="!form.hasOther3"
                        :model="form.other3"
                        @update-data="updateData('other3', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!--blog 6-->
            <v-card class="mb-12 px-12">
              <v-layout py-12 pl-12 pr-8 mr-12 style="font-size: 16px;">
                <v-flex>
                  <!-- row 1 -->
                  <v-layout>
                    <v-flex
                      mr-4
                      pt-2
                      style="text-align: left;font-weight: bold;"
                    >
                      <span
                        >การปฏิบัติตามข้อกำหนดมีผลเพิ่มความเสี่ยงหรือเกิดอันตรายต่ออาสาสมัคร
                        หรือไม่</span
                      >
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout>
                    <v-flex mr-4 style="text-align: left;">
                      <span
                        >Does it have or post a significant rick or substantive
                        harm to research subjects?</span
                      >
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout pb-6>
                    <v-flex
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <v-radio-group v-model="form.hasIncreaseRisk" row>
                        <v-radio
                          color="#3E7662"
                          style="padding-right: 100px"
                          label="มี"
                          value="0"
                        ></v-radio>
                        <v-radio
                          @click.native="clearRedio('hasScreening')"
                          color="#3E7662"
                          label="ไม่มี"
                          value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <!--row 4-->
                  <v-layout>
                    <v-flex
                      pt-6
                      mr-4
                      style="text-align: left;font-weight: bold;"
                    >
                      <span
                        >การปฏิบัติตามข้อกำหนดมีผลต่อความน่าเชื่อถือของงานวิจัย
                        หรือไม่</span
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex mr-4 pt-2 style="text-align: left;">
                      <span
                        >Does it cause damage to the scientific integrity of
                        data collected? หรือไม่</span
                      >
                    </v-flex>
                  </v-layout>
                  <!-- row 5 -->
                  <v-layout pb-6>
                    <v-flex
                      mr-4
                      pt-2
                      style="text-align: right;font-weight: bold;"
                    >
                      <v-radio-group v-model="form.hasCauseDamage" row>
                        <v-radio
                          color="#3E7662"
                          style="padding-right: 100px"
                          label="มี"
                          value="0"
                        ></v-radio>
                        <v-radio
                          @click.native="clearRedio('hasScreening')"
                          color="#3E7662"
                          label="ไม่มี"
                          value="1"
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <v-layout mt-3 style="background-color: #3E7662;">
              <v-flex
                my-8
                ml-8
                style="text-align: center;font-size: 18px;color: white"
              >
                <div style="font-weight: bold">
                  มีการดำเนินการหรือมาตรการที่จะป้องกันการเกิดเหตุการณ์ซ้ำหรือไม่?
                  <br />
                </div>
                <div>
                  Which corrective actions or plans to prevent the future
                  events?
                </div>
              </v-flex>
            </v-layout>
            <!-- blog 7 -->
            <v-card class="mb-12 px-12">
              <v-layout pt-12 mt-2 style="padding-left: 70px">
                <v-flex>
                  <!-- row 1 -->
                  <v-layout>
                    <v-flex
                      :class="!form.hasRetraining ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        v-model="form.hasRetraining"
                        hide-details
                        color="#3E7662"
                        label="อบรบทีมวิจัยเกี่ยวกับวิธีดำเนินการวิจัยหรือหัตถการในโครงการวิจัย (retraining the research team about the research procedure on date "
                        @change="clearCheckbox('hasRetraining')"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex ml-3>
                      <textfield-form-append
                        hide-detail
                        :disabled="!form.hasRetraining"
                        :model="form.retraining"
                        @update-data="updateData('retraining', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="
                        !form.hasGCPTraining ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        v-model="form.hasGCPTraining"
                        hide-details
                        color="#3E7662"
                        label="อบรบการปฏิบัติการทางคลินิกที่ดี (ICH GCP training on"
                        @change="clearCheckbox('hasGCPTraining')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex class="text-start" ml-3>
                      <textfield-form-append
                        hide-detail
                        :disabled="!form.hasGCPTraining"
                        :model="form.GCPTraining"
                        @update-data="updateData('GCPTraining', $event)"
                      />
                    </v-flex>
                    <v-flex mt-3 shrink>
                      <span>)</span>
                    </v-flex>
                  </v-layout>
                  <!--row 3-->
                  <v-layout>
                    <v-flex
                      shrink
                      :class="!form.hasHireStaff ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        v-model="form.hasHireStaff"
                        hide-details
                        color="#3E7662"
                        label="เพิ่มเจ้าหน้าที่หรือผู้ร่วมวิจัย (Hire more staffs or co-researchers)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="
                        !form.hasIncreaseSecurity ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        v-model="form.hasIncreaseSecurity"
                        hide-details
                        color="#3E7662"
                        label="เพิ่มความปลอดภัยของข้อมูล (Increase sata security by)"
                        @change="clearCheckbox('hasIncreaseSecurity')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex class="text-start" ml-3>
                      <textfield-form-append
                        hide-detail
                        :disabled="!form.hasIncreaseSecurity"
                        :model="form.increaseSecurity"
                        @update-data="updateData('increaseSecurity', $event)"
                      />
                    </v-flex>
                    <v-flex mt-3 shrink>
                      <span>)</span>
                    </v-flex>
                  </v-layout>
                  <!-- row 4 -->
                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="
                        !form.hasFixOldMachine ? '' : 'color-label-checkbox'
                      "
                    >
                      <v-checkbox
                        hide-details
                        color="#3E7662"
                        v-model="form.hasFixOldMachine"
                        label="ซ่อมหรือจัดหาเครื่องมือทดแทน (Fix or Replace the old machine)"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>

                  <v-layout>
                    <v-flex
                      mt-1
                      shrink
                      :class="!form.hasOther4 ? '' : 'color-label-checkbox'"
                    >
                      <v-checkbox
                        hide-details
                        color="#3E7662"
                        v-model="form.hasOther4"
                        label="อื่นๆ (Others) ระบุ"
                        @change="clearCheckbox('hasOther4')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex class="text-start" ml-3>
                      <textfield-form-append
                        hide-detail
                        :disabled="!form.hasOther4"
                        :model="form.other4"
                        @update-data="updateData('other4', $event)"
                      />
                    </v-flex>
                    <v-flex mt-3 shrink>
                      <span>)</span>
                    </v-flex>
                  </v-layout>

                  <v-layout
                    pb-8
                    mb-8
                    style="background-color: white;padding-right: 70px;padding-top: 250px"
                  >
                    <v-flex>
                      <v-layout>
                        <v-flex xs5 pl-3 mr-6 class="text-field-center">
                          <textfield-form-append
                            :model="form.signature"
                            css="font-weight: bold;"
                            label="ผู้วิจัย"
                            hide-detail
                            @update-data="updateData('signature', $event)"
                          ></textfield-form-append>
                        </v-flex>
                        <v-flex xs4>
                          <DateInputForm
                            :model="reportDate"
                            label="วันที่"
                            @update-data="updateDate('reportDate', $event)"
                          ></DateInputForm>
                        </v-flex>
                      </v-layout>
                      <v-layout mt-n3 px-12>
                        <v-flex xs5>
                          <v-layout justify-center>
                            <v-flex shrink style="font-weight: bold">
                              <span>(</span>
                            </v-flex>
                            <v-flex xs8 mx-2 mt-n3 class="text-field-center">
                              <textfield-form-append
                                :model="form.signature"
                                @update-data="updateData('signature', $event)"
                              />
                            </v-flex>
                            <v-flex shrink style="font-weight: bold">
                              <span>)</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-layout ml-n12 style="padding-top: 150px">
                        <v-flex style="font-weight: bold" d-flex justify-start>
                          <span @click="setData"
                            >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span
                          >
                        </v-flex>
                        <v-flex style="font-weight: bold" d-flex justify-end>
                          <span>หน้า 1 จาก 1 หน้า</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
            <!--save button-->
            <v-layout>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      class="mx-4"
                      depressed
                      color="#ffffff"
                      @click="viewData"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed dark color="#3E7662" @click="save">
                      <v-icon class="mr-3">add</v-icon>
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <loading
              color="#527281"
              :active.sync="isLoading"
              :can-cancel="false"
              :is-full-pageAndLine="fullpageAndLine"
            ></loading>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import DateInputFormAppend from "../../components/input/DateInputFormAppend";
import CheckboxForm from "../../components/input/CheckboxForm";
import { mapState } from "vuex";
// import editAdd from "../../components/table/editAdd";

export default {
  name: "FormRF06",
  components: {
    // CheckboxForm,
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
    // DateInputFormAppend,
    // editAdd,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    selected: [],
    dialog: false,
    form: {
      researchID: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      amountOfReport: "",
      amountOfNotFollow: "",
      hasDeviation: "",
      hasViolation: "",
      hasRandom: "",
      hasEnrollment: "",
      hasNotScreening: "",
      hasScreening: "",
      hasFailureTherapy: "",
      hasFailureAccomplish: "",
      hasFollowUp: "",
      hasOther1: "",
      other1: "",
      hasNonCompliance: "",
      hasDelaySAEReport: "",
      hasDelayContinuingReport: "",
      hasUseUnstampedInformed: "",
      hasAccountabilityDrug: "",
      hasOther2: "",
      other2: "",
      summaryOfTheEvent: "",
      hasSubjectWithdraw: "",
      hasSubjectWithdrawWithFollowUp: "",
      hasSubjectRemainButFollow: "",
      hasSubjectRemainButStudy: "",
      hasSponsorNotified: "",
      hasOther3: "",
      other3: "",
      hasIncreaseRisk: "",
      hasCauseDamage: "",
      hasRetraining: "",
      retraining: "",
      hasGCPTraining: "",
      GCPTraining: "",
      hasHireStaff: "",
      hasIncreaseSecurity: "",
      increaseSecurity: "",
      hasFixOldMachine: "",
      hasOther4: "",
      other4: "",
      signature: "",
      reportDate: "",
    },
    subjectData: [
      {
        subjectNumber: "",
        dateOfEvents: "",
        dateOfAcknowledgement: "",
      },
    ],
    researchAllHeaders: [
      { text: "Version", value: "version", align: "center" },
      { text: "หน้า / บรรทัด", value: "pageAndLine", align: "center" },
      { text: "ข้อมูลเดิม / ข้อเสนอแนะ", value: "suggestion", align: "center" },
      { text: "ลบ", value: "delete", align: "center" },
    ],
    userID: "",
    reportDate: "",
  }),
  watch: {
    form: {
      handler(val) {
        if (val.hasDeviation === true) {
          this.form.hasViolation = "";
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    //   if (this.user.currentRole !== 3) {
    //    this.$router.go(-1);
    // }

    this.userID = this.$route.query.userID;
    this.getFormRF05();
  },
  methods: {
    updateData(name, val) {
      this.form[name] = val;
    },
    updateDate(name, val) {
      if (name === "reportDate") {
        this.form.reportDate = val.date;
        this.reportDate = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    updateDataMultiRow(name, index, val) {
      this.subjectData[index][name] = val;
    },
    viewData() {
      this.$router.push({
        name: "ViewDataPostApprove",
        query: { id: this.userID },
      });
    },
    getFormRF05() {
      this.$store
        .dispatch("FormRF/getRF05", this.$route.query.rfID)
        .then((res) => {
          if (res !== "don't have deviation report yet") {
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.form.amountOfReport = res.amountOfReport;
            this.form.amountOfNotFollow = res.amountOfNotFollow;
            this.form.hasDeviation = res.hasDeviation == 1;
            this.form.hasRandom = res.hasRandom == 1;
            this.form.hasEnrollment = res.hasEnrollment == 1;
            this.form.hasNotScreening = res.hasNotScreening == 1;
            this.form.hasScreening = res.hasScreening == 1;
            this.form.hasFailureTherapy = res.hasFailureTherapy == 1;
            this.form.hasFailureAccomplish = res.hasFailureAccomplish == 1;
            this.form.hasFollowUp = res.hasFollowUp == 1;
            this.form.hasOther1 = res.hasOther1 == 1;
            this.form.other1 = res.other1;
            this.form.hasNonCompliance = res.hasNonCompliance == 1;
            this.form.hasDelaySAEReport = res.hasDelaySAEReport == 1;
            this.form.hasDelayContinuingReport =
              res.hasDelayContinuingReport == 1;
            this.form.hasUseUnstampedInformed =
              res.hasUseUnstampedInformed == 1;
            this.form.hasAccountabilityDrug = res.hasAccountabilityDrug == 1;
            this.form.hasOther2 = res.hasOther2 == 1;
            this.form.other2 = res.other2;
            this.form.summaryOfTheEvent = res.summaryOfTheEvent;
            this.form.hasSubjectWithdraw = res.hasSubjectWithdraw == 1;
            this.form.hasSubjectWithdrawWithFollowUp =
              res.hasSubjectWithdrawWithFollowUp == 1;
            this.form.hasSubjectRemainButFollow =
              res.hasSubjectRemainButFollow == 1;
            this.form.hasSubjectRemainButStudy =
              res.hasSubjectRemainButStudy == 1;
            this.form.hasSponsorNotified = res.hasSponsorNotified == 1;
            this.form.hasOther3 = res.hasOther3 == 1;
            this.form.other3 = res.other3;
            this.form.hasIncreaseRisk = res.hasIncreaseRisk == 1;
            this.form.hasCauseDamage = res.hasCauseDamage == 1;
            this.form.hasRetraining = res.hasRetraining == 1;
            this.form.retraining = res.retraining;
            this.form.hasGCPTraining = res.hasGCPTraining == 1;
            this.form.GCPTraining = res.GCPTraining;
            this.form.hasHireStaff = res.hasHireStaff == 1;
            this.form.hasIncreaseSecurity = res.hasIncreaseSecurity == 1;
            this.form.increaseSecurity = res.increaseSecurity;
            this.form.hasFixOldMachine = res.hasFixOldMachine == 1;
            this.form.hasOther4 = res.hasOther4 == 1;
            this.form.other4 = res.other4;
            this.form.signature = res.signature;
            this.form.reportDate = res.reportDate;
            this.reportDate = this.changeDate(res.reportDate);
            this.subjectData = res.deviation_report_subject_data;
          }
        });
    },
    save() {
      Swal.fire({
        title: "คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.form["subjectData"] = this.subjectData;
          this.form["researchID"] = this.$route.query.id;
          this.isLoading = true;
          this.$store
            .dispatch("FormRF/saveRF05", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              this.viewData();
              // this.$router.push('/profile')
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
              // Swal.fire({
              //     title: 'Save failed!',
              //     text: 'บันทึกไม่สำเร็จ',
              //     icon: 'warning',
              // });
              // this.isLoading = false
            });
        }
      });
    },
    otherChangeCheckbox() {
      if (!this.form.hasOtherChange) {
        this.form.otherChange = "";
      }
    },
    clearCheckbox(name) {
      console.log("name", name);
      if (name === "hasDeviation") {
        if (!this.form.hasDeviation) {
          console.log("val", this.form.hasDeviation);
          this.form.hasDeviation = !this.form.hasDeviation;
          this.form.hasRandom = false;
          this.form.hasEnrollment = false;
          this.form.hasNotScreening = false;
          this.form.hasScreening = false;
          this.form.hasFailureTherapy = false;
          this.form.hasFailureAccomplish = false;
          this.form.hasFollowUp = false;
          this.form.hasOther1 = false;
          this.form.other1 = "";
        }
      }
      if (name === "hasViolation") {
        if (!this.form.hasViolation) {
          console.log("val", this.form.hasViolation);
          this.form.hasViolation = !this.form.hasViolation;
          this.form.hasRandom = false;
          this.form.hasEnrollment = false;
          this.form.hasNotScreening = false;
          this.form.hasScreening = false;
          this.form.hasFailureTherapy = false;
          this.form.hasFailureAccomplish = false;
          this.form.hasFollowUp = false;
          this.form.hasOther1 = false;
          this.form.other1 = "";
        }
      }
      if (name === "hasOther1") {
        if (!this.form.hasOther1) {
          this.form.other1 = "";
        }
      }
      if (name === "hasNonCompliance") {
        if (!this.form.hasNonCompliance) {
          this.form.hasDelaySAEReport = false;
          this.form.hasDelayContinuingReport = false;
          this.form.hasUseUnstampedInformed = false;
          this.form.hasAccountabilityDrug = false;
          this.form.hasOther2 = false;
          this.form.other2 = "";
        }
      }
      if (name === "hasOther2") {
        if (!this.form.hasOther2) {
          this.form.other2 = "";
        }
      }
      if (name === "hasOther3") {
        if (!this.form.hasOther3) {
          this.form.other3 = "";
        }
      }
      if (name === "hasOther4") {
        if (!this.form.hasOther4) {
          this.form.other4 = "";
        }
      }
      if (name === "hasRetraining") {
        if (!this.form.hasRetraining) {
          this.form.retraining = "";
        }
      }
      if (name === "hasGCPTraining") {
        if (!this.form.hasGCPTraining) {
          this.form.GCPTraining = "";
        }
      }
      if (name === "hasIncreaseSecurity") {
        if (!this.form.hasIncreaseSecurity) {
          this.form.increaseSecurity = "";
        }
      }
    },
    clearRedio(name) {
      if (name === "hasAddOperate") {
        this.form.addOperate = "";
        this.form.hasAddOperate = "1";
      }
      if (name === "hasExpandTime") {
        this.form.expandTime = "";
        this.form.hasExpandTime = "1";
      }
      if (name === "hasAdjustOtherMethod") {
        this.form.adjustOtherMethod = "";
        this.form.hasAdjustOtherMethod = "1";
      }
      if (name === "hasAdjustMethod") {
        this.form.adjustMethod = "";
        this.form.hasAdjustMethod = "1";
      }
      if (name === "hasScreening") {
        this.form.screening = "";
        this.form.hasScreening = "1";
      }
    },
    add(index) {
      this.subjectData.push({
        subjectNumber: "",
        dateOfEvents: "",
        dateOfAcknowledgement: "",
      });
    },
    remove(index) {
      this.subjectData.splice(index, 1);
    },
    setData() {
      this.form.researchID = "test";
      this.form.researchCode = "test";
      this.form.firstName = "test";
      this.form.lastName = "test";
      this.form.researchName = "test";
      this.form.amountOfReport = "test";
      this.form.amountOfNotFollow = "test";
      this.form.hasDeviation = true;
      this.form.hasRandom = true;
      this.form.hasEnrollment = true;
      this.form.hasNotScreening = true;
      this.form.hasScreening = true;
      this.form.hasFailureTherapy = true;
      this.form.hasFailureAccomplish = true;
      this.form.hasFollowUp = true;
      this.form.hasOther1 = true;
      this.form.other1 = "test";
      this.form.hasNonCompliance = true;
      this.form.hasDelaySAEReport = true;
      this.form.hasDelayContinuingReport = true;
      this.form.hasUseUnstampedInformed = true;
      this.form.hasAccountabilityDrug = true;
      this.form.hasOther2 = true;
      this.form.other2 = "test";
      this.form.summaryOfTheEvent = "test";
      this.form.hasSubjectWithdraw = true;
      this.form.hasSubjectWithdrawWithFollowUp = true;
      this.form.hasSubjectRemainButFollow = true;
      this.form.hasSubjectRemainButStudy = true;
      this.form.hasSponsorNotified = true;
      this.form.hasOther3 = true;
      this.form.other3 = "test";
      this.form.hasIncreaseRisk = "0";
      this.form.hasCauseDamage = "0";
      this.form.hasRetraining = true;
      this.form.retraining = "test";
      this.form.hasGCPTraining = true;
      this.form.GCPTraining = "test";
      this.form.hasHireStaff = true;
      this.form.hasIncreaseSecurity = true;
      this.form.increaseSecurity = "test";
      this.form.hasFixOldMachine = true;
      this.form.hasOther4 = true;
      this.form.other4 = "test";
      this.form.signature = "test";
      this.form.reportDate = "2020-02-12";
      this.subjectData = [
        {
          subjectNumber: "111",
          dateOfEvents: "111",
          dateOfAcknowledgement: "111",
        },
        {
          subjectNumber: "222",
          dateOfEvents: "222",
          dateOfAcknowledgement: "222",
        },
      ];
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
.color-label-checkbox {
  label.v-label.theme--light {
    color: #3e7662;
  }
}
</style>
